/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, themeV2 } from '@insticator/insticator-ui'; // iui-utils

/* ++++++++++ --------------- MONETIZATION FORM WRAPPER (ROW) : STYLES --------------- ++++++++++ */
export default theme => ({
    monetization: {
        flex: 1,
        '& .expandablesection': {
            display: 'flex',
            flexDirection: 'column',
            border: 'none',
            marginBottom: 0,
            boxShadow: 'none',
            '& .opened': {
                overflow: 'visible'
            },
            '& .innerWrap': {
                display: 'flex',
                padding: 0,
                backgroundColor : '#FFF'
            }
        },
        '& .configcontroller': {
            marginBottom: themeV2.spacing[2]
        },
        '& .innerWrap': {
            margin: 0,
            padding: pxToEm(30),
        },
        '& > .collapsable': {
            overflow: 'hidden',
            maxHeight: '0px',
            transition: 'max-height 0.3s'
        },
        '& .collapsable.opened': {
            maxHeight: pxToEm(3000)
        },
        '& .labeltext': {
            color: themeV2.color.primary.main
        }
    },
    sortableSections: {
        '& .sectiongroup': {
            maxWidth: '98%',
            padding: pxToEm(20),
            margin: themeV2.spacing[2],
            background: 'white',
            borderRadius: pxToEm(5),
            '& .sortablelist': {
                maxWidth: pxToEm(400),
            }
        },
        '& .sectiongroupdescription': {
            marginBottom: pxToEm(15),
        }
    },
    selectionSection : {
        display: 'flex',
        flexDirection: 'column',
        gap: pxToEm(24),
        marginTop: pxToEm(24),
    },
    checkListSection:{
        display: 'flex',
        flexDirection: 'row',
        gap: pxToEm(24),
        padding: pxToEm(12),
    },
    reportSection:{
        padding: '16px 32px 32px 32px',
        background: 'white',
        '& > .sectiongroup': {
            marginTop : pxToEm(12),
        }
    },
    reportHeader: {
        color : '#061240',
        fontFamily: "Work Sans",
        fontSize: pxToEm(16),
        fontStyle: 'normal',
        fontWeight: 700,
        lineHeight: pxToEm(22),
    },
    formatSettings: {
        padding: '16px 32px 32px 32px',
    },
    deliverySettingsSection : {
        display: 'flex',
        flexDirection: 'column',
        padding: '16px 32px 32px 32px',
        paddingBottom: '0px !important',
        marginBottom: pxToEm(32),
    },
    deliverySettingsTitle : {
        color: '#061240)',
        fontFamily: "Work Sans",
        fontSize: pxToEm(16),
        fontStyle: 'normal',
        fontWeight: '700',
        lineHeight: pxToEm(22),
    }

});
